import type { IServiceGetOne } from '../../interfaces/serviceGetOne';
import { translateKey } from '../../../translate';

export function ServiceBlock(props: { service: IServiceGetOne }) {
    return (
        <>
            <h3>{props.service.name}</h3>
            <ul>
                <li>
                    {translateKey('common.code')}: {props.service.code}
                </li>
                <li>
                    {translateKey('common.type')}: {translateKey(`serviceTypeEnum.${props.service.serviceType}`)}
                </li>
            </ul>
        </>
    );
}
